import {jwtDecode} from 'jwt-decode';
import {exchangeEmailWithCode} from '../store/slices/exchange_token_slice';
import {redirect} from 'react-router-dom';
import {isFulfilled, isRejected} from '@reduxjs/toolkit';
import {store as AppStore} from '../store/store';
import {loginRedirectRoute} from '../support/login_redirect_route.ts';

export async function tokenLoader(store: typeof AppStore, url: string) {
    const token = new URL(url).searchParams.get('token');
    if (token) {
        const decodedToken = jwtDecode(token);
        if (
            'code' in decodedToken &&
            'email' in decodedToken &&
            typeof decodedToken.email === 'string' &&
            typeof decodedToken.code === 'string'
        ) {
            try {
                const result = await store.dispatch(
                    exchangeEmailWithCode({email: decodedToken.email, code: decodedToken.code}),
                );

                if (isRejected(result)) {
                    if (result.error.message?.toLowerCase()?.includes('customer not found')) {
                        throw new Error('Customer not found');
                    }
                }

                if (isFulfilled(result) && result.payload.login?.token != null) {
                    localStorage.setItem('token', result.payload.login.token);
                    const redirectTo = new URL(url).searchParams.get('redirect');
                    redirect(loginRedirectRoute(result.payload.login, redirectTo));
                }

                return redirect('/');
            } catch (error) {
                console.warn(error);
                return redirect('/login');
            }
        }
    }
    return null;
}
